export const score = [5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9];
export const ptescores = Array(90 - 10 + 1)
  .fill()
  .map((_, idx) => 10 + idx);
